import React, { useState, useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
  Root,
  ContainerCreateCardCredit,
  ContainerCardCredit,
  ContainerFormCardCredit,
  FormCardCredit,
  FormCardCreditBoxName,
  FormCardCreditBoxNumber,
  FormCardCreditBoxExp,
  FormCardCreditBoxCVC,
  FormCardCreditBoxBTN,
  FormCardCreditTitle,
  FormCardCreditInput,
} from './styles';

import InputMask from 'react-input-mask';

import CardPayment from '../../../components/CardPayment';
import {
  userSavePaymentESitef,
  userListPaymentRequest,
} from '../../../store/modules/auth/actions';
import { StoreState } from '../../../store/createStore';
import { UserCard } from '../../../store/modules/auth/types';
import { setIsCategory } from '../../../store/modules/parameter/actions';
import ReactCreditCard from '../../../components/ReactCreditCard';

const Payment: React.FC = () => {
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    name: '',
    number: '',
    expiration: '',
    cvc: '',
  });

  const [errors, setErrors] = useState({
    expiration: false,
  });
  const {
    user: {
      data: { cpf_cnpj, id },
    },
  } = useSelector((state: StoreState) => state.auth);

  const handleSubmit = useCallback(
    async data => {
      if (errors.expiration === false) {
        alert('Vencimento cartão invalido');
        return;
      }

      if (data.number && data.expiration && data.name) {
        const cardPayload: UserCard = {
          card_number: data.number,
          expiry_date: data.expiration,
          authorizer_id: '2',
          merchant_usn: id || '',
          customer_id: cpf_cnpj || '',
          full_name: data.name,
        };

        dispatch(userSavePaymentESitef(cardPayload));
        setValues({
          name: '',
          number: '',
          expiration: '',
          cvc: '',
        });
      }
    },
    [errors, cpf_cnpj, dispatch, id],
  );

  useEffect(() => {
    dispatch(userListPaymentRequest());
    dispatch(setIsCategory(false));
  }, [dispatch]);

  const handleChange = useCallback(
    event => {
      const { name, value } = event.target;

      // eslint-disable-next-line prefer-const
      let valueStr = name !== 'name' ? value.replace(/\s/g, '') : value;

      if (name === 'expiration') {
        const pattern = /^(0[1-9]|1[012])\/\d{2}$/;
        const erro = pattern.test(valueStr);

        setErrors(e => ({ ...e, [name]: erro }));
      }

      setValues(v => ({ ...v, [name]: valueStr }));
    },
    [setValues, setErrors],
  );

  const [focused, setFocus] = useState<string | undefined>(undefined);
  const handleFocus = useCallback(
    event => setFocus(event.target.name as string),
    [setFocus],
  );
  const handleBlur = useCallback(() => setFocus(undefined), [setFocus]);

  return (
    <Root>
      <div style={{ marginTop: '10px' }} />
      <ContainerCreateCardCredit>
        <ContainerCardCredit>
          <ReactCreditCard
            {...values}
            focused={focused}
            placeholderName="Nome do titular"
          />
        </ContainerCardCredit>
        <ContainerFormCardCredit>
          <FormCardCredit>
            <FormCardCreditBoxNumber>
              <FormCardCreditTitle>Número do cartão</FormCardCreditTitle>
              <InputMask
                mask="9999 9999 9999 9999"
                name="number"
                placeholder="9999 9999 9999 9999"
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                value={values.number}
                style={{
                  marginTop: '6px',
                  padding: '6px',
                  width: '100%',
                  height: '35px',
                  border: '1px solid var(--primary)',
                  borderRadius: '10px',
                }}
              />
            </FormCardCreditBoxNumber>
            <FormCardCreditBoxName>
              <FormCardCreditTitle>Nome do titular</FormCardCreditTitle>
              <FormCardCreditInput
                name="name"
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                value={values.name}
              />
            </FormCardCreditBoxName>
            <FormCardCreditBoxExp>
              <FormCardCreditTitle>Data de validade</FormCardCreditTitle>
              <InputMask
                mask="99/99"
                name="expiration"
                placeholder="MM/YY"
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                value={values.expiration}
                style={{
                  marginTop: '6px',
                  padding: '6px',
                  width: '100%',
                  height: '35px',
                  border: '1px solid var(--primary)',
                  borderRadius: '10px',
                }}
              />
            </FormCardCreditBoxExp>
            <FormCardCreditBoxCVC style={{ marginBottom: '20px' }}>
              <FormCardCreditTitle>CVC</FormCardCreditTitle>
              <InputMask
                mask="999"
                name="cvc"
                placeholder="999"
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                value={values.cvc}
                style={{
                  marginTop: '6px',
                  padding: '6px',
                  width: '100%',
                  height: '35px',
                  border: '1px solid var(--primary)',
                  borderRadius: '10px',
                }}
              />
            </FormCardCreditBoxCVC>
            <FormCardCreditBoxBTN onClick={() => handleSubmit(values)}>
              <span>Salvar</span>
            </FormCardCreditBoxBTN>
          </FormCardCredit>
        </ContainerFormCardCredit>
      </ContainerCreateCardCredit>

      <CardPayment title="Meus Cartões" nobtnNew={true} />
    </Root>
  );
};

export default Payment;
